import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/i18n';
import React from 'react';
export const OrganizeConfirmationModalContent = _ref => {
  let {
    isSiteLanguageRTL,
    t,
    onLearnMoreClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true
  }, isSiteLanguageRTL ? t('accessibility-wizard.footer.dom-order.organize-confirmation-modal.RTL-content') : t('accessibility-wizard.footer.dom-order.organize-confirmation-modal.LTR-content')), /*#__PURE__*/React.createElement(SectionHelper, {
    skin: "warning"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }),
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        underline: "always",
        onClick: onLearnMoreClick
      })
    },
    i18nKey: isSiteLanguageRTL ? 'accessibility-wizard.footer.dom-order.organize-confirmation-modal.RTL-section-helper' : 'accessibility-wizard.footer.dom-order.organize-confirmation-modal.LTR-section-helper',
    t: t
  })));
};
//# sourceMappingURL=organize-confirmation-modal-content.js.map